var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container section-story"},_vm._l((_vm.section.text),function(paragraph,idx){return _c('p',{key:((_vm.section.sname) + "-" + idx),staticClass:"is-size-4"},[_vm._v(" "+_vm._s(paragraph)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }